import { render, staticRenderFns } from "./ElButtonPrideti.vue?vue&type=template&id=8e7b9bec&scoped=true&"
import script from "./ElButtonPrideti.vue?vue&type=script&lang=js&"
export * from "./ElButtonPrideti.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonPrideti.vue?vue&type=style&index=0&id=8e7b9bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7b9bec",
  null
  
)

export default component.exports